import { Link } from 'react-router-dom';

export function Chain({ items, className = '' }) {
  return (
    <ol className={`chain ${className}`}>
      {items.map((x) => <li key={x}>{x}</li>)}
    </ol>
  );
}

export function Checklist({ items }) {
  return (
    <ul className="checklist">
      {items.map((x) => <li key={x}><i className="bi bi-check2" /> {x}</li>)}
    </ul>
  );
}

export function Section({ id, tone, children }) {
  return (
    <section id={id} className={`section ${tone ? `tone-${tone}` : ''}`}>
      <div className="container">{children}</div>
    </section>
  );
}

export function Heading({ kicker, title, sub }) {
  return (
    <div className="sec-head">
      {kicker && <span className="kicker">{kicker}</span>}
      <h2>{title}</h2>
      {sub && <p className="muted">{sub}</p>}
    </div>
  );
}

export const requestLink = (intent) => `/service-request?intent=${intent}`;

export function CtaLink({ to, children, kind = 'accent' }) {
  return <Link to={to} className={`btn ${kind}`}>{children} <i className="bi bi-arrow-right" /></Link>;
}
